"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRoarTranslations = exports.getTranslations = void 0;
const camelize_1 = require("./camelize");
const taskStore_1 = require("../../../taskStore");
const papaparse_1 = __importDefault(require("papaparse"));
require("regenerator-runtime/runtime");
let translations = {};
function parseTranslations(translationData) {
    for (const [key, value] of Object.entries(translationData)) {
        translations[(0, camelize_1.camelize)(key.trim())] = value;
    }
}
const getTranslations = async (isDev, taskName, configLanguage) => {
    // adult reasoning strings are in the math item bank
    if (taskName === 'adult-reasoning') {
        taskName = 'egma-math';
    }
    async function downloadJson(url) {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Failed to fetch translations (${response.status}): ${url}`);
        }
        const data = await response.json();
        const rows = data;
        parseTranslations(rows);
        return rows;
    }
    async function loadTranslationJsons(urls) {
        return Promise.all(urls.map((url) => downloadJson(url)));
    }
    async function fetchData() {
        const urls = [
            `https://storage.googleapis.com/levante-assets-${isDev ? 'dev' : 'prod'}/translations/itembank/general/${configLanguage}/item-bank-translations.json`,
        ];
        // Load different json if hearts-and-flowers and isRoarApp
        if (taskName !== 'hearts-and-flowers' || !(0, taskStore_1.taskStore)().isRoarApp) {
            urls.push(`https://storage.googleapis.com/levante-assets-${isDev ? 'dev' : 'prod'}/translations/itembank/${taskName}/${configLanguage}/item-bank-translations.json`);
        }
        else if (taskName === 'hearts-and-flowers' && (0, taskStore_1.taskStore)().isRoarApp) {
            urls.push(`https://storage.googleapis.com/roar-levante-tasks/translations/itembank/hearts-and-flowers/${configLanguage}/item-bank-translations.json`);
        }
        // hostile attribution requires some strings in the theory of mind item bank
        if (taskName === 'hostile-attribution') {
            urls.push(`https://storage.googleapis.com/levante-assets-${isDev ? 'dev' : 'prod'}/translations/itembank/theory-of-mind/${configLanguage}/item-bank-translations.json`);
        }
        try {
            // The intro task only needs the shared/general bank — there is no task-specific `intro`
            // item bank, so fetching one would 404. urls[0] is always the general bank.
            await loadTranslationJsons(taskName === 'intro' ? [urls[0]] : urls);
            (0, taskStore_1.taskStore)('translations', translations);
        }
        catch (error) {
            console.error('Error:', error);
        }
    }
    await fetchData();
};
exports.getTranslations = getTranslations;
// Temporarily keep these here for backward compatibility (roar-inference)
function getRoarRowData(row, language, nonLocalDialect) {
    const translation = row[language.toLowerCase()];
    // Only need this because we don't have base language translations for all languages.
    // Ex we have 'es-co' but not 'es'
    const noBaseLang = Object.keys(row).find((key) => key.includes(nonLocalDialect)) || '';
    return translation || row[nonLocalDialect] || row[noBaseLang] || row['en'];
}
function parseRoarTranslations(translationData, configLanguage) {
    const nonLocalDialect = configLanguage.split('-')[0].toLowerCase();
    translationData.forEach((row) => {
        translations[(0, camelize_1.camelize)(row.item_id)] = getRoarRowData(row, configLanguage, nonLocalDialect);
    });
    (0, taskStore_1.taskStore)('translations', translations);
}
const getRoarTranslations = async (configLanguage) => {
    if (!configLanguage) {
        return;
    }
    function downloadCSV(url) {
        return new Promise((resolve, reject) => {
            papaparse_1.default.parse(url, {
                download: true,
                header: true,
                skipEmptyLines: true,
                complete: function (results) {
                    parseRoarTranslations(results.data, configLanguage || '');
                    resolve(results.data);
                },
                error: function (error) {
                    reject(error);
                },
            });
        });
    }
    async function parseCSVs(urls) {
        const promises = urls.map((url) => downloadCSV(url));
        return Promise.all(promises);
    }
    async function fetchData() {
        const urls = [
            // This will eventually be split into separate files
            `https://storage.googleapis.com/road-dashboard/item-bank-translations.csv`,
        ];
        try {
            await parseCSVs(urls);
        }
        catch (error) {
            console.error('Error:', error);
        }
    }
    await fetchData();
};
exports.getRoarTranslations = getRoarTranslations;
